import styled from 'styled-components';
import CartSummaryMobileBar from './CartSummaryMobileBar';
import colors from '@general/colors';
import { cartData } from '@.storybook/cart.mock';

export default {
    title: 'IcscApp/Organisms/CartSummaryMobileBar',
};

const BackgroundStyled = styled.div`
    background: ${colors.ultraLightGray};
    display: flex;
    justify-content: center;
    padding: 20px;
`;

export const Default = () => {
    return (
        <BackgroundStyled>
            <div style={{ width: '390px' }}>
                <CartSummaryMobileBar
                    cart={cartData}
                    navLabel="Payment Info"
                    onExpandToggleClick={() => alert('Order Summary Clicked')}
                    onNavClick={() => alert('Payment Info Clicked')}
                />
            </div>
        </BackgroundStyled>
    );
};
